export default "__VITE_ASSET__BT$c3c$J__"